export default __webpack_public_path__ + "static/media/figure_main.b2e0354f.png";